import { render, staticRenderFns } from "./configPage.vue?vue&type=template&id=75008330&scoped=true"
import script from "./configPage.vue?vue&type=script&lang=js"
export * from "./configPage.vue?vue&type=script&lang=js"
import style0 from "./configPage.vue?vue&type=style&index=0&id=75008330&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75008330",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75008330')) {
      api.createRecord('75008330', component.options)
    } else {
      api.reload('75008330', component.options)
    }
    module.hot.accept("./configPage.vue?vue&type=template&id=75008330&scoped=true", function () {
      api.rerender('75008330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/zdy_dragging/config/configPage.vue"
export default component.exports